import { useMutation } from '@tanstack/react-query';
import { sendMessage } from '../../core/services/contact.service';

export const useSendMessage = () => {
  return useMutation({
    mutationKey: ['send-message'],
    mutationFn: (data) => sendMessage(data),
  });
};
